// The "New today" rows as the website knows them: the keys the server answers with, and the wording keys.
// The RULES (which cases are in a row, what "today" means) live on the server only (server/needs_today.js).
export const NEEDS_ROW_KEYS = ['price_above_order', 'duplicate_invoice', 'order_missing', 'documents_overdue', 'vat_error'];

// Agents say "Documents late" (Leo A7); the other company types keep their wording.
export const needsRowLabelKey = (key, kind) => (kind === 'agent' && key === 'documents_overdue' ? 'needs.row.documents_late' : `needs.row.${key}`);

// The rows an agent's Home shows: no VAT row (Leo A1: VAT checking is not in this version). The other company types keep all five.
export const needsRowsFor = (kind) => (kind === 'agent' ? NEEDS_ROW_KEYS.filter((k) => k !== 'vat_error') : NEEDS_ROW_KEYS);

// '/cases?needs=<row>&scope=today|open' (the Cases page shows exactly the ids the server returns for it)
export const needsListPath = (row, scope = 'today') => `/cases?needs=${row}&scope=${scope}`;

// The redesigned agent list for a Home row: the cases that are new today (redesign/NewTodayView.jsx). Pure agents only; others keep needsListPath.
export const newTodayPath = (row) => `/cases/new-today/${row}`;

// Reads the filter out of a location.search string; null when there is none or the row is not one of ours.
export function parseNeedsFilter(search) {
  const p = new URLSearchParams(search || '');
  const row = p.get('needs');
  if (!NEEDS_ROW_KEYS.includes(row)) return null;
  return { row, scope: p.get('scope') === 'open' ? 'open' : 'today' };
}
